var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39132_3882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6816 27.075C38.6816 28.5948 34.164 29.8269 28.5913 29.8269C23.0186 29.8269 18.501 28.5948 18.501 27.075C18.501 25.5552 23.0186 24.3231 28.5913 24.3231C34.164 24.3231 38.6816 25.5552 38.6816 27.075Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6806 33.496C38.6806 35.0159 34.163 36.2479 28.5903 36.2479C23.0176 36.2479 18.5 35.0159 18.5 33.496C18.5 31.9762 23.0176 30.7441 28.5903 30.7441C34.163 30.7441 38.6806 31.9762 38.6806 33.496Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6806 39.9172C38.6806 41.437 34.163 42.6691 28.5903 42.6691C23.0176 42.6691 18.5 41.437 18.5 39.9172C18.5 38.3973 23.0176 37.1653 28.5903 37.1653C34.163 37.1653 38.6806 38.3973 38.6806 39.9172Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6806 46.3383C38.6806 47.8582 34.163 49.0902 28.5903 49.0902C23.0176 49.0902 18.5 47.8582 18.5 46.3383C18.5 44.8185 23.0176 43.5864 28.5903 43.5864C34.163 43.5864 38.6806 44.8185 38.6806 46.3383Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5903 29.8268C34.163 29.8268 38.6806 28.5948 38.6806 27.075V31.6614C38.6806 33.1813 34.163 34.4133 28.5903 34.4133C23.0176 34.4133 18.5 33.1813 18.5 31.6614V27.075C18.5 28.5948 23.0176 29.8268 28.5903 29.8268Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5903 36.248C34.163 36.248 38.6806 35.0159 38.6806 33.4961V38.0826C38.6806 39.6024 34.163 40.8345 28.5903 40.8345C23.0176 40.8345 18.5 39.6024 18.5 38.0826V33.4961C18.5 35.0159 23.0176 36.248 28.5903 36.248Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5903 42.6691C34.163 42.6691 38.6806 41.4371 38.6806 39.9172V44.5037C38.6806 46.0236 34.163 47.2556 28.5903 47.2556C23.0176 47.2556 18.5 46.0236 18.5 44.5037V39.9172C18.5 41.4371 23.0176 42.6691 28.5903 42.6691Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5903 49.0902C34.163 49.0902 38.6806 47.8581 38.6806 46.3383V50.9248C38.6806 52.4446 34.163 53.6766 28.5903 53.6766C23.0176 53.6766 18.5 52.4446 18.5 50.9248V46.3383C18.5 47.8581 23.0176 49.0902 28.5903 49.0902Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3959 38.9556C65.0062 47.6623 59.1302 55.8875 50.2715 57.3272C41.4127 58.7669 32.9259 52.8758 31.3156 44.1691C29.7053 35.4625 35.5813 27.2372 44.44 25.7975C53.2987 24.3579 61.7855 30.249 63.3959 38.9556Z",
    fill: "url(#paint0_linear_39132_3882)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8159 54.864C57.2904 53.6492 62.2483 46.7092 60.8896 39.3629C59.5309 32.0167 52.3701 27.0461 44.8956 28.2608C37.4211 29.4755 32.4632 36.4156 33.8219 43.7618C35.1806 51.1081 42.3413 56.0787 49.8159 54.864ZM50.2715 57.3272C59.1302 55.8875 65.0062 47.6623 63.3959 38.9556C61.7855 30.249 53.2987 24.3579 44.44 25.7975C35.5813 27.2372 29.7053 35.4625 31.3156 44.1691C32.9259 52.8758 41.4127 58.7669 50.2715 57.3272Z",
    fill: "url(#paint1_linear_39132_3882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9368 40.5321L41.3483 40.3027C41.3644 39.407 41.4914 38.5788 41.7294 37.8182C41.9733 37.0491 42.3139 36.3723 42.751 35.7877C43.1955 35.202 43.7275 34.721 44.347 34.345C44.9739 33.9677 45.677 33.7158 46.4563 33.5891C47.4929 33.4207 48.4155 33.4754 49.2242 33.7533C50.0389 34.0228 50.7503 34.4505 51.3585 35.0364L50.4863 36.3392C50.4214 36.4391 50.3516 36.5323 50.2767 36.6189C50.2005 36.6983 50.0816 36.7511 49.9198 36.7774C49.7581 36.8037 49.6004 36.7698 49.4467 36.6756C49.3003 36.5804 49.1262 36.4784 48.9244 36.3698C48.7212 36.2539 48.4729 36.1603 48.1795 36.0889C47.8861 36.0175 47.5115 36.0189 47.0557 36.0929C46.2691 36.2208 45.6495 36.5968 45.197 37.2211C44.7519 37.8442 44.5129 38.7018 44.4801 39.7937L49.8065 38.9281L49.9728 39.8277C50.0049 40.0011 49.9585 40.1799 49.8335 40.3639C49.7145 40.5396 49.5264 40.6483 49.269 40.6901L44.5713 41.4535C44.584 41.5631 44.601 41.6757 44.6224 41.7913C44.6425 41.8997 44.6632 42.0117 44.6846 42.1273L44.7687 42.5825L49.257 41.8531L49.4233 42.7527C49.4554 42.9261 49.409 43.1048 49.284 43.2889C49.165 43.4645 48.9805 43.5727 48.7306 43.6133L45.2348 44.1814C45.6458 45.298 46.1718 46.0945 46.8127 46.5709C47.4536 47.0472 48.1674 47.2215 48.954 47.0937C49.2848 47.0399 49.5619 46.9614 49.7851 46.8581C50.0157 46.7537 50.2068 46.6407 50.3585 46.5193C50.5176 46.3967 50.6459 46.2717 50.7435 46.1442C50.8397 46.0094 50.927 45.8873 51.0052 45.7779C51.0907 45.6672 51.1716 45.5722 51.2478 45.4928C51.3313 45.4123 51.4319 45.3624 51.5495 45.3433C51.6451 45.3278 51.725 45.3297 51.7891 45.349C51.8593 45.36 51.9385 45.3992 52.0267 45.4667L53.5665 46.4222C53.2063 47.2995 52.6605 48.0133 51.9294 48.5638C51.1982 49.1143 50.3069 49.475 49.2556 49.6459C48.3881 49.7869 47.5828 49.7726 46.8396 49.6031C46.1025 49.4252 45.4321 49.1173 44.8286 48.6795C44.2252 48.2417 43.6942 47.6842 43.2357 47.007C42.7773 46.3298 42.396 45.5582 42.092 44.6921L40.7466 44.9108L40.4459 43.285L41.6479 43.0897C41.6259 43.0114 41.6082 42.9361 41.5948 42.8639C41.5815 42.7916 41.5674 42.7158 41.5527 42.6363C41.5313 42.5207 41.5106 42.4087 41.4906 42.3003C41.4779 42.1907 41.4645 42.0775 41.4505 41.9607L40.2375 42.1579L39.9368 40.5321Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39132_3882",
    x1: 51.7307,
    y1: 31.7171,
    x2: 42.0756,
    y2: 45.6265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78135,
    stopColor: "#D5D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39132_3882",
    x1: 41.6143,
    y1: 38.4358,
    x2: 47.2464,
    y2: 30.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604267,
    stopColor: "#B1B0F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39132_3882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinStack);
export default __webpack_public_path__ + "static/media/coin-stack.2e9b2f97517f09ccf6fcdb9413f5d285.svg";
export { ForwardRef as ReactComponent };